import React, {useState} from 'react';
import Landmark from '@core/scripts/components/landmark-adapter.js';
import {urls} from '../urlHelper.js';
import LoginForm from './LoginForm.jsx';
import PageContainer from '../../common/PageContainer.jsx';
import BackButton from '../../common/BackButton.jsx';
import ForgotPasswordProcessor from '../forgot-password/ForgotPasswordProcessor.jsx';

export default function LoginPage({
    texts,
    email,
    loginFormAction,
    siteKeyLogin,
    siteKeyForgotPassword,
    isCaptchaEnabled,
    isCaptchaV2Enabled,
    captchaLang,
}) {
    const [forgotPassword, setForgotPassword] = useState(false);

    const handleForgotPassword = () => {
        setForgotPassword(true);
        Landmark.sendClickLandmark('login_pwvergessen');
    };

    const handleClose = () => {
        setForgotPassword(false);
    };

    return (
        <PageContainer>
            <LoginForm
                texts={texts}
                username={email}
                loginFormAction={loginFormAction}
                siteKeyLogin={siteKeyLogin}
                isCaptchaEnabled={isCaptchaEnabled}
                isCaptchaV2Enabled={isCaptchaV2Enabled}
                captchaLang={captchaLang}
                onForgotPassword={handleForgotPassword}
            />
            <div className="pb-safe-area-inset">
                <BackButton label={texts['bff_back_to_cart']} url={urls.CART_URL} />
            </div>
            {!!forgotPassword && (
                <ForgotPasswordProcessor
                    texts={texts}
                    siteKey={siteKeyForgotPassword}
                    isCaptchaEnabled={isCaptchaEnabled}
                    isCaptchaV2Enabled={isCaptchaV2Enabled}
                    captchaLang={captchaLang}
                    onClose={handleClose}
                />
            )}
        </PageContainer>
    );
}
